/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmStrukturaVlastnostiObsah extends GContentBase<SeznamAdmStrukturaVlastnostiObsahObj> {
        private seznamObj: SeznamAdmStrukturaVlastnostiObsahObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmStrukturaVlastnostiObsahObj());
            var columnOrder = "k_v,{0}ixs_vla_txt,dat_zmena,zmenu_provedl";
            var ixsStvTxt = "";
            if (this.seznamObj.tabOpen == undefined || this.seznamObj.tabOpen == null)
                ixsStvTxt = "ixs_stv_txt,";
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmStrukturaVlastnostiObsahNew",
                contentCaption: "jres:33000459", //RC 33000457 : Hodnoty vlastnost�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_stv_txt} - {ixs_vla_txt}"
                },
                gridSettings: {
                    columnOrder: columnOrder.format(ixsStvTxt)
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmStrukturaVlastnostiObsahObj extends GAdmSeznamBase {
        private ixs_stv: string;

        create() {

        }

        updateGridFormat(gridFormat: Gordic.Data.GridFormat<any>) {
            var columnType = new Gordic.Data.GridFormat().addTextColumn({
                name: "type",
                caption: "jres:33000553", //RC 33000553 : Typ
                cellTemplate: (row) => {
                    if (row.ixs_stv) {
                        if (row.ixs_stv != "") {
                            var type = row.ixs_vla.substring(4, 7);
                            if (type == "00V")
                                return "jres:29932128"
                            else (type == "00S")
                            return "jres:29931622"
                        }
                    }
                    return "";
                }
            }).columns;
            gridFormat.columns.splice(1, 0, columnType[0]);
            return gridFormat;
        }

        openDetail(data: any, isNew: boolean) {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnostiObsah", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmStrukturaVlastnostiObsah",
                newRecord: isNew,
                ixs_stv: isNew == true ? (this.ixs_stv ? this.ixs_stv : null) : data.ixs_stv,
                ixs_vla: isNew == true ? null : data.ixs_vla
            }, {
                height: 800,
                width: 800
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                {
                    action: this.cnt.actions.actNewDetail,
                    caption: "jres:33000552", //RC 33000552 : Nov� vazba
                    favorite: true
                },
                "actAddToComparison*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                dropdown: true,
                model: "model.ixs_stv=value.ixs_stv",
                name: "ixs_stv",
                disabled: (this.ixs_stv) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_stv)
                hardFilter["ixs_stv"] = this.ixs_stv;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_stv)
                data["ixs_stv"] = this.ixs_stv;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmStrukturaVlastnostiObsah.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_stv, data.ixs_vla),
                nazev: "{0} - {1}".format(data["ixs_stv_txt"], data["ixs_vla_txt"])
            }
        }
    }
}